<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return 'a'
      }
      return 'router-link'
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      if (to === '/mapIndex') { 
        return {
          // 临时将参数通传，方便地图页面接受
          to: { path: to, query: {id : localStorage.getItem('activeParkId')} }
        }
      } else {
        return {
          to: { path: to }
        }
      }
      
    }
  }
}
</script>
